import { analytics } from "./company/analytics.service";
import { companyCredits } from "./company/companyCredits.service";
import { company } from "./company/company.service";
import { employee } from "./employee/employee.service";
import { document } from "services/document-service/document.service";
import { taxTable } from "./taxTable.service";

export const Api = () => ({
  analytics,
  company,
  companyCredits,
  employee,
  document,
  taxTable,
});

interface ApiCallParams {
  apiCall: () => Promise<any>;
  onResult?: (res: any) => void;
  onError?: (err: any) => void;
  onCompleted?: () => void;
}

export const handleApiCall = async ({
  apiCall,
  onResult = (res) => {},
  onError = (err) => {},
  onCompleted = () => {},
}: ApiCallParams) => {
  try {
    const res = await apiCall();
    onResult(res);
  } catch (err) {
    onError(err);
  } finally {
    onCompleted();
  }
};
